import { createStore } from "vuex";

export default createStore({
  state() {
    return {
      isLoading: false,
      isAuthenticated: false,
      shop: {},
      token: null,
    };
  },
  getters: {
    getShop(state) {
      return state.shop;
    },
  },
  mutations: {
    initializeStore(state) {
      if (localStorage.getItem("shop")) {
        state.shop = JSON.parse(localStorage.getItem("shop"));
      } else {
        localStorage.setItem("shop", JSON.stringify(state.shop));
      }

      if (localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
        state.isAuthenticated = true;
      } else {
        state.token = null;
        state.isAuthenticated = false;
      }
    },
    setShop(state, shop) {
      state.shop = shop;
    },
    setIsLoading(state, status) {
      state.isLoading = status;
    },
    setToken(state, token) {
      state.token = token;
      state.isAuthenticated = true;
    },
    removeToken(state) {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("isShopOpen");
      state.shop = {};
    },
    // openStore(state, shop) {
    //   state.shop = { ...state.shop, ...shop };
    //   console.log(state.shop);
    // },
  },
  actions: {},
  modules: {},
});
